import React ,{useState, useEffect} from "react";
import  Api from "../../utils/Api/Api";
import { ErrorFallback } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";

import styles from "./CoinNWallet.module.css"
import FleekCoin from "../../asset/icons/fleek-coin-logo.png"
import { symbolFor } from "../../utils/format";

export const CoinNWallet = ({isLoggedIn})=>{
    const [fleekCoins,setFleekCoins] = useState([]);
    const [loading,setLoading] = useState(false);
    const [hasError,setError] = useState(false);

    // Get currency type from localStorage
    const currencyType = localStorage.getItem('current_currency_type') || 'inr';
    const currencySymbol = symbolFor(currencyType);

    useEffect(()=>{
        const fetchCartData = async ()=>{
            try {
                let [{data:fleekCoins}] = await Promise.all([ Api.GetFleekCoins()]);     
                setFleekCoins(fleekCoins);
            }
            catch(err) {
                console.log('=========')
                setError(true);
            }
            setLoading(false)
        }
        if(isLoggedIn)
        fetchCartData();
    },[])

    if(hasError) {
        return <ErrorFallback />
    }
    if(loading) {
        return <Loading />
    }

    // Coins are worth rupees (coin_value_in_inr) or dollars (coin_value) and
    // nothing else: in any other currency there is no figure to show.
    if (currencyType !== 'inr' && currencyType !== 'usd') return null;

    // Use coin_value for USD and coin_value_in_inr for INR
    const coinValue = currencyType === 'usd' ? fleekCoins?.coin_value : fleekCoins?.coin_value_in_inr;
    
    return(
        <div className={styles.container}>
            <img className={styles.FleekCoin} src={FleekCoin} alt="FleekCoin"/>
            <p className={styles.priceText}>{currencySymbol} {coinValue || 0}</p>
        </div>
    )
}